import React from 'react'

import { useSystemStore, SYSTEM_TYPE } from '@/app/store/systemStore'
import { GlonassoftTransferPage } from './GlonassoftTransferPage'
import { WialonTransferPage } from './WialonTransferPage'
import { GeliosTransferPage } from './GeliosTransferPage'
import { StandardTransferPage } from './StandardTransferPage'

export const TransferPage: React.FC = () => {
  const { selectedSystem } = useSystemStore()

  if (selectedSystem === SYSTEM_TYPE.GLONASSOFT)
    return <GlonassoftTransferPage />
  if (selectedSystem === SYSTEM_TYPE.WIALON) return <WialonTransferPage />
  if (selectedSystem === SYSTEM_TYPE.GELIOS) return <GeliosTransferPage />
  return <StandardTransferPage />
}
